export enum ButtonVariant {
  PRIMARY,
  INVERTED,
  DARK,
  MONOCHROME,
  YELLOW,
  LOADING,
}
